import { apiRequest } from '../../lib/api';
import {
  guestAccessSchema,
  okSchema,
  recallConfigSchema,
  whopConfigSaveSchema,
  whopConfigSchema,
  whopProbeSchema,
  zoomSetupConfigSchema,
} from '../../lib/schemas';
import type {
  GuestAccessConfig,
  RecallConfig,
  WhopConfig,
  WhopProbeProduct,
  WhopProductConfig,
  ZoomSetupConfig,
} from '../../types';

export interface ZoomAccountInput {
  index: number;
  accountId: string;
  clientId: string;
  clientSecret?: string;
  webhookSecret?: string;
}

export interface RecallConfigInput {
  apiKey: string;
  region: string;
}

export interface WhopConfigInput {
  apiKey: string;
  companyId: string;
  products: WhopProductConfig[];
}

export function getZoomSetup(signal?: AbortSignal): Promise<ZoomSetupConfig> {
  return apiRequest('/api/zoom/config', zoomSetupConfigSchema, signal ? { signal } : {});
}

export function saveZoomAccounts(accounts: ZoomAccountInput[]) {
  return apiRequest('/api/zoom/config', okSchema, {
    method: 'POST',
    body: JSON.stringify({ accounts }),
  });
}

export function getGuestAccess(signal?: AbortSignal): Promise<GuestAccessConfig> {
  return apiRequest('/api/guest-access', guestAccessSchema, signal ? { signal } : {});
}

export function saveGuestPasscode(passcode: string): Promise<GuestAccessConfig> {
  return apiRequest('/api/guest-access', guestAccessSchema, {
    method: 'POST',
    body: JSON.stringify({ passcode }),
  });
}

export function getRecallConfig(signal?: AbortSignal): Promise<RecallConfig> {
  return apiRequest('/api/recall/config', recallConfigSchema, signal ? { signal } : {});
}

export function saveRecallConfig(input: RecallConfigInput): Promise<RecallConfig> {
  return apiRequest('/api/recall/config', recallConfigSchema, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function getWhopConfig(signal?: AbortSignal): Promise<WhopConfig> {
  return apiRequest('/api/whop/config', whopConfigSchema, signal ? { signal } : {});
}

export function saveWhopConfig(input: WhopConfigInput) {
  return apiRequest('/api/whop/config', whopConfigSaveSchema, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function probeWhop(signal?: AbortSignal): Promise<WhopProbeProduct[]> {
  const result = await apiRequest('/api/whop/probe', whopProbeSchema, signal ? { signal } : {});
  return result.products;
}
